import React, { useState } from "react";

export default function AllowedPaymentMethods() {
  const [selectedMethods, setSelectedMethods] = useState([]);
  const [updated, setUpdated] = useState(false);

  const paymentMethods = [
    { id: "bankTransfer", name: "Bank Transfer" },
    { id: "visa", name: "VISA" },
    { id: "mastercard", name: "Mastercard" },
    { id: "verve", name: "Verve" },
    { id: "payWithPhone", name: "Pay with Phone" },
    { id: "eNaira", name: "eNaira" },
    { id: "paypal", name: "PayPal" },
    { id: "stripe", name: "Stripe" },
    { id: "alipay", name: "Alipay" },
    { id: "bitcoin", name: "Bitcoin" },
    { id: "applePay", name: "Apple Pay" },
    { id: "googlePay", name: "Google Pay" },
  ];

  const handleCheckboxChange = (method) => {
    setSelectedMethods((prevSelected) =>
      prevSelected.includes(method)
        ? prevSelected.filter((item) => item !== method)
        : [...prevSelected, method]
    );
  };

  const isChecked = (method) => selectedMethods.includes(method);

  const handleUpdateClick = () => {
    setUpdated(true);
    console.log("Selected Payment Methods:", selectedMethods);
    setTimeout(() => setUpdated(false), 3000); // Reset the update message after 3 seconds
  };

  return (
    <div className="gateway-settings-tab">
      <div className="payment-methods-container">
        <h5>Select Allowed Payment Methods</h5>
        <div className="payment-methods-list">
          {paymentMethods.map((method) => (
            <div key={method.id} className="payment-method">
              <input
                type="checkbox"
                id={method.id}
                value={method.name}
                checked={isChecked(method.name)}
                onChange={() => handleCheckboxChange(method.name)}
              />
              <label htmlFor={method.id}>{method.name}</label>
            </div>
          ))}
        </div>

        {/* Output Selected Methods */}
        <div className="selected-methods">
          <h6>Selected Methods:</h6>
          {selectedMethods.length > 0 ? (
            <ul>
              {selectedMethods.map((method) => (
                <li key={method}>{method}</li>
              ))}
            </ul>
          ) : (
            <p>No payment method selected</p>
          )}
        </div>
        <button className="update-btn" onClick={handleUpdateClick}>
          Update Selected Methods
        </button>
      </div>
    </div>
  );
}
